import { MENU_CLICKED } from "./types";

export const changedMenu = (menuId, props=null) => async dispatch => {
    dispatch({ type: MENU_CLICKED, menuId: menuId, props: props});
}